/* eslint-disable */
// prettier-ignore
import * as Types from '../../../../../../graphql/__generated__';

import { DocumentNode } from 'graphql';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type CrmManagement_InvestorExtensionSchemaQueryVariables = Types.Exact<{
  [key: string]: never;
}>;

export type CrmManagement_InvestorExtensionSchemaQuery = {
  readonly __typename?: 'Query';
  readonly investorExtensionSchema: ReadonlyArray<{
    readonly __typename?: 'InvestorExtensionSchema';
    readonly id: string;
    readonly category: Types.ExtendedDataCategory;
    readonly columnName?: string | null;
    readonly displayName?: string | null;
  }>;
};

export type CrmManagement_AdminInvestorExtensionSchemaQueryVariables = Types.Exact<{
  tenantId: Types.Scalars['UUID']['input'];
}>;

export type CrmManagement_AdminInvestorExtensionSchemaQuery = {
  readonly __typename?: 'Query';
  readonly adminInvestorExtensionSchema: ReadonlyArray<{
    readonly __typename?: 'InvestorExtensionSchema';
    readonly id: string;
    readonly category: Types.ExtendedDataCategory;
    readonly columnName?: string | null;
    readonly displayName?: string | null;
  }>;
};

export type CrmManagement_InvestorExtensionSchemaFieldsFragment = {
  readonly __typename?: 'InvestorExtensionSchema';
  readonly id: string;
  readonly category: Types.ExtendedDataCategory;
  readonly columnName?: string | null;
  readonly displayName?: string | null;
};

export const CrmManagement_InvestorExtensionSchemaFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CrmManagement_InvestorExtensionSchemaFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'InvestorExtensionSchema' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'category' } },
          { kind: 'Field', name: { kind: 'Name', value: 'columnName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export const CrmManagement_InvestorExtensionSchemaDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'CrmManagement_InvestorExtensionSchema' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'investorExtensionSchema' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'CrmManagement_InvestorExtensionSchemaFields' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CrmManagement_InvestorExtensionSchemaFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'InvestorExtensionSchema' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'category' } },
          { kind: 'Field', name: { kind: 'Name', value: 'columnName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useCrmManagement_InvestorExtensionSchemaQuery__
 *
 * To run a query within a React component, call `useCrmManagement_InvestorExtensionSchemaQuery` and pass it any options that fit your needs.
 * When your component renders, `useCrmManagement_InvestorExtensionSchemaQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCrmManagement_InvestorExtensionSchemaQuery({
 *   variables: {
 *   },
 * });
 */
export function useCrmManagement_InvestorExtensionSchemaQuery(
  baseOptions?: Apollo.QueryHookOptions<
    CrmManagement_InvestorExtensionSchemaQuery,
    CrmManagement_InvestorExtensionSchemaQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    CrmManagement_InvestorExtensionSchemaQuery,
    CrmManagement_InvestorExtensionSchemaQueryVariables
  >(CrmManagement_InvestorExtensionSchemaDocument, options);
}
export function useCrmManagement_InvestorExtensionSchemaLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    CrmManagement_InvestorExtensionSchemaQuery,
    CrmManagement_InvestorExtensionSchemaQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    CrmManagement_InvestorExtensionSchemaQuery,
    CrmManagement_InvestorExtensionSchemaQueryVariables
  >(CrmManagement_InvestorExtensionSchemaDocument, options);
}
// @ts-ignore
export function useCrmManagement_InvestorExtensionSchemaSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    CrmManagement_InvestorExtensionSchemaQuery,
    CrmManagement_InvestorExtensionSchemaQueryVariables
  >
): Apollo.UseSuspenseQueryResult<
  CrmManagement_InvestorExtensionSchemaQuery,
  CrmManagement_InvestorExtensionSchemaQueryVariables
>;
export function useCrmManagement_InvestorExtensionSchemaSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        CrmManagement_InvestorExtensionSchemaQuery,
        CrmManagement_InvestorExtensionSchemaQueryVariables
      >
): Apollo.UseSuspenseQueryResult<
  CrmManagement_InvestorExtensionSchemaQuery | undefined,
  CrmManagement_InvestorExtensionSchemaQueryVariables
>;
export function useCrmManagement_InvestorExtensionSchemaSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        CrmManagement_InvestorExtensionSchemaQuery,
        CrmManagement_InvestorExtensionSchemaQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    CrmManagement_InvestorExtensionSchemaQuery,
    CrmManagement_InvestorExtensionSchemaQueryVariables
  >(CrmManagement_InvestorExtensionSchemaDocument, options);
}
export type CrmManagement_InvestorExtensionSchemaQueryHookResult = ReturnType<
  typeof useCrmManagement_InvestorExtensionSchemaQuery
>;
export type CrmManagement_InvestorExtensionSchemaLazyQueryHookResult = ReturnType<
  typeof useCrmManagement_InvestorExtensionSchemaLazyQuery
>;
export type CrmManagement_InvestorExtensionSchemaSuspenseQueryHookResult = ReturnType<
  typeof useCrmManagement_InvestorExtensionSchemaSuspenseQuery
>;
export type CrmManagement_InvestorExtensionSchemaQueryResult = Apollo.QueryResult<
  CrmManagement_InvestorExtensionSchemaQuery,
  CrmManagement_InvestorExtensionSchemaQueryVariables
>;
export const CrmManagement_AdminInvestorExtensionSchemaDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'CrmManagement_AdminInvestorExtensionSchema' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'tenantId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'adminInvestorExtensionSchema' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'tenantId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'tenantId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'CrmManagement_InvestorExtensionSchemaFields' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CrmManagement_InvestorExtensionSchemaFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'InvestorExtensionSchema' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'category' } },
          { kind: 'Field', name: { kind: 'Name', value: 'columnName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useCrmManagement_AdminInvestorExtensionSchemaQuery__
 *
 * To run a query within a React component, call `useCrmManagement_AdminInvestorExtensionSchemaQuery` and pass it any options that fit your needs.
 * When your component renders, `useCrmManagement_AdminInvestorExtensionSchemaQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCrmManagement_AdminInvestorExtensionSchemaQuery({
 *   variables: {
 *      tenantId: // value for 'tenantId'
 *   },
 * });
 */
export function useCrmManagement_AdminInvestorExtensionSchemaQuery(
  baseOptions: Apollo.QueryHookOptions<
    CrmManagement_AdminInvestorExtensionSchemaQuery,
    CrmManagement_AdminInvestorExtensionSchemaQueryVariables
  > &
    (
      | { variables: CrmManagement_AdminInvestorExtensionSchemaQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    CrmManagement_AdminInvestorExtensionSchemaQuery,
    CrmManagement_AdminInvestorExtensionSchemaQueryVariables
  >(CrmManagement_AdminInvestorExtensionSchemaDocument, options);
}
export function useCrmManagement_AdminInvestorExtensionSchemaLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    CrmManagement_AdminInvestorExtensionSchemaQuery,
    CrmManagement_AdminInvestorExtensionSchemaQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    CrmManagement_AdminInvestorExtensionSchemaQuery,
    CrmManagement_AdminInvestorExtensionSchemaQueryVariables
  >(CrmManagement_AdminInvestorExtensionSchemaDocument, options);
}
// @ts-ignore
export function useCrmManagement_AdminInvestorExtensionSchemaSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    CrmManagement_AdminInvestorExtensionSchemaQuery,
    CrmManagement_AdminInvestorExtensionSchemaQueryVariables
  >
): Apollo.UseSuspenseQueryResult<
  CrmManagement_AdminInvestorExtensionSchemaQuery,
  CrmManagement_AdminInvestorExtensionSchemaQueryVariables
>;
export function useCrmManagement_AdminInvestorExtensionSchemaSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        CrmManagement_AdminInvestorExtensionSchemaQuery,
        CrmManagement_AdminInvestorExtensionSchemaQueryVariables
      >
): Apollo.UseSuspenseQueryResult<
  CrmManagement_AdminInvestorExtensionSchemaQuery | undefined,
  CrmManagement_AdminInvestorExtensionSchemaQueryVariables
>;
export function useCrmManagement_AdminInvestorExtensionSchemaSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        CrmManagement_AdminInvestorExtensionSchemaQuery,
        CrmManagement_AdminInvestorExtensionSchemaQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    CrmManagement_AdminInvestorExtensionSchemaQuery,
    CrmManagement_AdminInvestorExtensionSchemaQueryVariables
  >(CrmManagement_AdminInvestorExtensionSchemaDocument, options);
}
export type CrmManagement_AdminInvestorExtensionSchemaQueryHookResult = ReturnType<
  typeof useCrmManagement_AdminInvestorExtensionSchemaQuery
>;
export type CrmManagement_AdminInvestorExtensionSchemaLazyQueryHookResult = ReturnType<
  typeof useCrmManagement_AdminInvestorExtensionSchemaLazyQuery
>;
export type CrmManagement_AdminInvestorExtensionSchemaSuspenseQueryHookResult = ReturnType<
  typeof useCrmManagement_AdminInvestorExtensionSchemaSuspenseQuery
>;
export type CrmManagement_AdminInvestorExtensionSchemaQueryResult = Apollo.QueryResult<
  CrmManagement_AdminInvestorExtensionSchemaQuery,
  CrmManagement_AdminInvestorExtensionSchemaQueryVariables
>;
